import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.detallesFacturacion.list', {
    url: '?{date:date}',
    data: {
      title: 'Detalles de Facturación',
    },
    resolve: {
      Data: (FinanzasDetallesFacturacion, $stateParams) => $stateParams.date ? FinanzasDetallesFacturacion.$query($stateParams.date) : undefined,
    },
    template,
    controllerAs: '$ctrl',
    controller (Data, $location, $moment, $stateParams) {
      var $ctrl = this

      $ctrl.options = {
        date: $stateParams['date'] || $moment().startOf('month').toDate(),
      }

      $ctrl.data = Data

      $ctrl.$query = function () {
        $location.search({date: $ctrl.options.date.toYMD()})
      }
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/detallesFacturacion/lista/finances-detallesFacturacion-list.js